import { render, staticRenderFns } from "./RouteStickyMenu.vue?vue&type=template&id=5a46c2ca&"
import script from "./RouteStickyMenu.vue?vue&type=script&lang=ts&"
export * from "./RouteStickyMenu.vue?vue&type=script&lang=ts&"
import style0 from "./RouteStickyMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports